import type { FileContent } from "@opencode-ai/sdk/v2"
import { getFilename } from "@opencode-ai/core/util/path"

export function downloadFile(filePath: string, content: FileContent) {
  const filename = getFilename(filePath) || "download"

  let blob: Blob
  if (content.type === "binary" && content.encoding === "base64") {
    blob = new Blob([base64ToArrayBuffer(content.content)], {
      type: content.mimeType || "application/octet-stream",
    })
  } else {
    blob = new Blob([content.content], { type: content.mimeType || "text/plain" })
  }

  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes.buffer
}
